import Nav from "../Nav";
import Carousel from "../Carousel";
import { Link } from "react-router-dom";
import Head from "../Head";

export const HerbarioMuestra = () => {
  var settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
        },
      },
    ],
  };
  return (
    <>
      <Head title="Muestras -  Herbario doméstico" />
      <Nav titulo="Herbario doméstico" link="/muestras" />
      <section
        id="about_me"
        className="mb-5  animate__fadeInDown wow animate__animated animate__delay-0s animate__slower"
      >
        <Carousel settings={settings}>
          <img
            src="../img/herbario_domestico/herbario_muestra (11).jpg"
            className="img-fluid"
            alt="Herbario doméstico"
          />
          <img
            src="../img/herbario_domestico/herbario_muestra (9).jpg"
            className="img-fluid"
            alt="Herbario doméstico"
          />
          <img
            src="../img/herbario_domestico/herbario_muestra (17).jpg"
            className="img-fluid"
            alt="Herbario doméstico"
          />
          <img
            src="../img/herbario_domestico/herbario_muestra (2).jpg"
            className="img-fluid"
            alt="Herbario doméstico"
          />
          <img
            src="../img/herbario_domestico/herbario_muestra (18).jpg"
            className="img-fluid"
            alt="Herbario doméstico"
          />
          <img
            src="../img/herbario_domestico/herbario_muestra (5).jpg"
            className="img-fluid"
            alt="Herbario doméstico"
          />

          <img
            src="../img/herbario_domestico/herbario_muestra (4).jpg"
            className="img-fluid"
            alt="Herbario doméstico"
          />
          <img
            src="../img/herbario_domestico/herbario_muestra (3).jpg"
            className="img-fluid"
            alt="Herbario doméstico"
          />
          <img
            src="../img/herbario_domestico/herbario_muestra (7).jpg"
            className="img-fluid"
            alt="Herbario doméstico"
          />
          <img
            src="../img/herbario_domestico/herbario_muestra (10).jpg"
            className="img-fluid"
            alt="Herbario doméstico"
          />
          <img
            src="../img/herbario_domestico/herbario_muestra (16).jpg"
            className="img-fluid"
            alt="Herbario doméstico"
          />
          <img
            src="../img/herbario_domestico/herbario_muestra (15).jpg"
            className="img-fluid"
            alt="Herbario doméstico"
          />
          <img
            src="../img/herbario_domestico/herbario_muestra (14).jpg"
            className="img-fluid"
            alt="Herbario doméstico"
          />
          <img
            src="../img/herbario_domestico/herbario_muestra (6).jpg"
            className="img-fluid"
            alt="Herbario doméstico"
          />
          <img
            src="../img/herbario_domestico/herbario_muestra (1).jpg"
            className="img-fluid"
            alt="Herbario doméstico"
          />
          <img
            src="../img/herbario_domestico/herbario_muestra (8).jpg"
            className="img-fluid"
            alt="Herbario doméstico"
          />
          <img
            src="../img/herbario_domestico/herbario_muestra (13).jpg"
            className="img-fluid"
            alt="Herbario doméstico"
          />
          <img
            src="../img/herbario_domestico/herbario_muestra (12).jpg"
            className="img-fluid"
            alt="Herbario doméstico"
          />
        </Carousel>
        <div className="row marMob ">
          <div className="col-12 mt-5 col-lg-7 text-md-start col-xl-9">
            <hr />
            <Link to="/proyectos/herbario_domestico">
              <h3 className="text-center fs-6">
                Rosario, 2022 - Centro Cultural Cine Lumiere
              </h3>
              <hr />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};
